import { Alert, Button, Col, Divider, Form, FormInstance, Input, message, Row, Select, Spin, Table, Upload, UploadFile } from 'antd'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { FormDatePicker } from '../../Components/FormDatePicker';
import { DeleteOutlined, EditOutlined, EyeOutlined, HistoryOutlined, UploadOutlined } from "@ant-design/icons";
import {
  getAssignedTo,
  getRequestDetailsById,
  getTaskOwnerStatus,
  getTaskInvestigatorStatus,
  getTaskSummaryDetails,
  InsertTasksAsync,
  UpdateTaskAsync,
  getTaskHistory,
} from '../../Helpers/APIEndpoints/Endpoints';
import { API } from '../../Axios/Axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../AuthStore/AuthStore';
import { RoleEnum } from '../../Enum/RoleEnum';
import { RequestStatusEnum } from '../../Enum/RequestStatusEnum';
import { TaskStatusEnum } from '../../Enum/TaskStatusEnum';
import { useActionHandler } from '../../Components/ActionHandlerContext';
import Modal from "antd/es/modal/Modal";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { ApiStatus } from '../../Enum/ApiStatusEnum';
import Loader from '../../Helpers/Loader/Loader';
import { stat } from 'fs';

dayjs.extend(utc);
dayjs.extend(timezone);

const TaskDetailsTab = (props: any) => {
  // const [form] = Form.useForm();
  const form = props.form;
  const { interfaceActionHandler } = useActionHandler();

  const [formOptions, setFormOptions] = React.useState<any>({});
  const [taskDetailsData, setTaskDetailsData] = React.useState<any>([]);

  const location = useLocation();
  const { RId } = location.state || {};

  const [alertMessage, setAlertMessage] = useState<string>("");
  const [acceptedTypes] = useState<string>(".doc,.docx,.pdf,.xlsx,.xls,.msg,.eml,.ppt,.pptx,.png,.jpg,.jpeg,.zip");
  const [maxDocCount] = useState<number>(5);
  const [maxFileSize] = useState<number>();
  const [totalMaxFilesSize] = useState<number>(30);
  const [fileList, setFileList] = useState<any[]>([]);

  const { commonContextParams } = useAuthStore();
  const [editingKey, setEditingKey] = useState<number | null>(null);
  const navigate = useNavigate();
  const [taskCurrentStatus, setTaskCurrentStatus] = useState<any>(null);
  const [isCurrentTaskExtended, setIsCurrentTaskExtended] = useState<any>(false);
  const [currentInvestigatorStatus, setCurrentInvestigatorStatus] = useState<any>(null);
  const [requestStatus, setRequestStatus] = useState<any>();
  const [closureDate, setClosureDate] = useState<any>();
  const [Investigator, setInvestigator] = useState<any>();

  const [ownerFiles, setOwnerFiles] = useState<UploadFile[]>([]);
  const [closureFiles, setClosureFiles] = useState<UploadFile[]>([]);
  const [deletedOwnerAttachmentIds, setDeletedOwnerAttachmentIds] = useState<string>("");
  const [isEditing, setIsEditing] = useState(false);
  //const [isCorrActionEditing, setCorrActionEditing] = useState(false);

  const [historyData, setHistoryData] = useState<any>([]);
  const [isHistoryIconClicked, setIsHistoryIconClicked] = useState(false);
  const [ShowForm, setShowForm] = useState(false);
  const [isReopenRequest, setisReopenRequest] = useState(false);
  const [isAddDisable, setisAddDisable] = useState(false);
  const [isTaskTable, setisTaskTable] = useState(false);

  //const [CACreatedForTask, setCorrActionEditingKey] = useState(false);

  const canShowForm =
    isEditing ||
    ((((Number(commonContextParams.roleId) == RoleEnum.Investigator) &&
      requestStatus == RequestStatusEnum.ActionAssignmentPendingWithInvestigator) ||
      ((Number(commonContextParams.roleId) == RoleEnum.CentralQaTeam) &&
        requestStatus == RequestStatusEnum.CorrectiveActionAssignmentPendingWithQa)));

  //const formRef = useRef<FormInstance>(null);
  const formRef = useRef<any>(null);

  const [loading, setLoading] = useState(false);

  const goToNextTab = () => {
    interfaceActionHandler?.NextTab?.();
  };

  const goToPrevTab = () => {
    interfaceActionHandler?.PrevTab?.();
  };

  // Assignee search states for lazy loading dropdown
  const [assigneeOptions, setAssigneeOptions] = useState<any[]>([]);
  const [assigneeLoading, setAssigneeLoading] = useState(false);

  const assigneeSearchTimeout = useRef<any>(null);

  // 🔥 FIX: Separate caches clearly
  const assigneeCache = useRef<Map<string, any[]>>(new Map()); // search term → options
  const assigneeIdCache = useRef<Map<number, any>>(new Map());       // id → {label,value}

  // Existing caches (OK)
  const assigneeFromTaskSummary = useRef<Map<number, any>>(new Map());

  //#region Role Base helper flags    
  // const isValidInvestigator =
  //   Number(commonContextParams?.userId) === Number(Investigator) &&
  //   Number(commonContextParams?.roleId) === RoleEnum.Investigator;

  const isUserInCommaList = (list: string, userId: number) => {
    if (!list) return false;

    return list
      .split(',')
      .map((x) => Number(x.trim()))
      .includes(userId);
  };

  const isValidInvestigator =
    Number(commonContextParams?.roleId) === Number(RoleEnum.Investigator) &&
    isUserInCommaList(Investigator, Number(commonContextParams?.userId));


  const isValidTaskOwner =
    Number(commonContextParams?.roleId) === RoleEnum.TaskActionOwner;

  const isInvestigator =
    Number(commonContextParams?.roleId) === RoleEnum.Investigator;

  const hasOldTask = taskDetailsData?.some((t: any) => t.taskDetailId);
  const hasNewTask = taskDetailsData?.some((t: any) => !t.taskDetailId);

  const isReopened =
    requestStatus === RequestStatusEnum.ActionAssignmentPendingWithInvestigator &&
    hasOldTask;

  const canInvestigatorSubmit =
    isInvestigator &&
    requestStatus === RequestStatusEnum.ActionAssignmentPendingWithInvestigator &&
    (
      (!isReopened && taskDetailsData?.length > 0) ||
      (isReopened && hasNewTask)
    );

  const _isTaskUpdate =
    requestStatus === RequestStatusEnum.TasksWipWithTaskOwner &&
    (isValidTaskOwner || isValidInvestigator);

  const _showUpdateButton =
    (_isTaskUpdate) &&
    (editingKey);


  const _disableUpdate =
    (isValidTaskOwner && taskCurrentStatus === TaskStatusEnum.Closed) ||
    (isValidInvestigator && currentInvestigatorStatus === TaskStatusEnum.Closed);

  const _showInvestigatorAdd =
    requestStatus === RequestStatusEnum.ActionAssignmentPendingWithInvestigator &&
    isValidInvestigator;

  const _showReset =
    (isValidInvestigator &&
      requestStatus === RequestStatusEnum.ActionAssignmentPendingWithInvestigator);
  //#endregion

  //#region Reset Fields on Reset Button
  const actionTabFields = [
    "taskTitle",
    "taskDescription",
    "assignedToId",
    "taskDeadline",
    "statusId",
    "remarks",
    "ownerAttachments",
    "InvestigatorStatus",
    "taskClosureRemarks",
    "correctiveactionfinding",
    "taskCorrectiveaction",
    "correctiveActionUserToIds",
    "correctiveActionDeadline",
    "correctiveActionOwnerStatus",
    "correctiveActionOwnerRemarks",
    "CorrectiveActionOwnerAttachments",
    "QAStatus",
    "QAClosureRemarks",
  ];

  const resetActionTab = () => {
    // 1. Reset all tab fields
    form.resetFields(actionTabFields);

    // 2. Clear uploads
    setOwnerFiles([]);
    setClosureFiles([]);

    // 3. Reset TASK states
    setEditingKey(null);
    setTaskCurrentStatus(null);
    setCurrentInvestigatorStatus(null);
    setIsCurrentTaskExtended(false);

    setisReopenRequest(false);
    setisAddDisable(false);


    // 5. Reset global editing flag
    setIsEditing(false);

    setAssigneeOptions([]);
    assigneeCache.current.clear();
    assigneeIdCache.current.clear();

    // 6. Clear hidden/internal fields
    form.setFieldsValue({
      assignedToId: [],
      hdntaskDetailId: null,
    });
  };

  //#endregion

  //#region Table Columns For Task and Corrective Actions
  const Taskcolumns = [
    // {
    //   title: 'Timestamp',
    //   dataIndex: 'timestamp',
    //   key: 'timestamp',
    // },
    {
      title: 'Title',
      dataIndex: 'taskTitle',
      key: 'taskTitle',
    },
    {
      title: 'Description',
      dataIndex: 'taskDescription',
      key: 'taskDescription',
    },
    {
      title: 'Assigned To',
      dataIndex: 'assignedToId',
      key: 'assignedToId',
      render: (value: any, record: any) => {
        // 1. If record already has name (like single select)
        if (record?.name) {
          return record.name;
        }

        if (!value) return "-";

        // 2. Normalize to array
        const values = Array.isArray(value) ? value : [value];

        const labels = values.map((item: any) => {
          const id = item?.value ?? item;

          const fromIdCache = assigneeIdCache.current.get(id);
          if (fromIdCache) return fromIdCache.label;

          // 3. First check formOptions
          const fromOptions = formOptions?.Assignee?.find(
            (opt: any) => opt.value == id
          )?.label;

          if (fromOptions) return fromOptions;

          // 4. Fallback to cache (same as your single select)
          return assigneeFromTaskSummary.current.get(id);
        });

        // 5. Clean + join
        return labels.filter(Boolean).join(", ") || "-";
      }
    },
    {
      title: 'Deadline',
      dataIndex: 'taskDeadline',
      key: 'taskDeadline',
      render: (value: any) => {
        // console.log('deadline value =>', value)
        return value ? dayjs(value)?.format('DD-MM-YYYY') : null
      },
    },
    {
      title: 'Status',
      dataIndex: 'taskInvestigatorStatus',
      key: 'taskInvestigatorStatus',
      render: (value: any) => {

        return value ? value : "Pending";
      },
    },
    // {
    //   title: 'Remarks',
    //   dataIndex: 'remarks',
    //   key: 'remarks',
    // },
    {
      title: 'Actions',
      key: 'actions',
      render: (_: any, record: any) => (
        <>
          {(((RequestStatusEnum.ActionAssignmentPendingWithInvestigator == requestStatus ||
            RequestStatusEnum.TasksWipWithTaskOwner == requestStatus) &&
            isValidInvestigator && record.investigatorStatusId != TaskStatusEnum.Closed) ||
            ((RequestStatusEnum.TasksWipWithTaskOwner == requestStatus) &&
              isValidTaskOwner && record.statusId != TaskStatusEnum.Closed)
          ) ?

            <Button type="link" onClick={() => handleEdit(record)}>
              <EditOutlined />
            </Button>
            :
            <Button type="link" onClick={() => handleEdit(record)}>
              <EyeOutlined />
            </Button>
          }
          {(RequestStatusEnum.ActionAssignmentPendingWithInvestigator == requestStatus &&
            commonContextParams?.roleId == RoleEnum.Investigator &&
            record.investigatorStatusId !== TaskStatusEnum.Closed
          ) ?

            <Button type="link" onClick={() => handleDelete(record)}>
              <DeleteOutlined />
            </Button>
            :
            <></>
          }

          <Button type="link" onClick={() => getHistoryGridData(record)}>
            <HistoryOutlined />
          </Button>

        </>
      ),
    },
  ];
  //#endregion

  //#region History
  const formatToLocal = (utcDate: string) => {
    return dayjs.utc(utcDate).local().format("DD-MM-YYYY hh:mm A");
  };

  const Historycolumns = [
    {
      title: "Timestamp",
      dataIndex: "timestamp",
      key: "timestamp",
      render: (value: string) => formatToLocal(value),
    },
    {
      title: "Role",
      dataIndex: "role",
    },
    {
      title: "Username",
      dataIndex: "username",
    },
    {
      title: "Status",
      dataIndex: "status",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      render: (value: string) => value || "-",
    },
    {
      title: "TAT",
      dataIndex: "tat",
    },
  ];

  const getHistoryGridData = async (record: any) => {
    try {
      const obj = {
        TaskDetailId: record?.key,
      };
      const res = await API.post(getTaskHistory, obj);
      console.log("history res ==>", res);

      if (res?.data?.data?.length > 0) {
        setHistoryData(res?.data?.data);
      }

      setIsHistoryIconClicked(true);
    } catch (error) {
      console.error("History API Error:", error);
    }
  };

  const handleHistoryClose = () => {
    setIsHistoryIconClicked(false);
    setHistoryData([]);
  };

  //#endregion

  //#region Task Details Methods
  const handleAdd = async () => {
    try {
      var Fields = ['taskTitle', 'taskDescription', 'assignedToId', 'taskDeadline'];
      const values = await form.validateFields(Fields);
      console.log("values on add", values);

      let assigneeName = "";

      if (values.assignedToId) {
        const items = Array.isArray(values.assignedToId)
          ? values.assignedToId
          : [values.assignedToId];

        const names = items.map((item: any) => {
          const id = item?.value ?? item;

          // 1. Try from dropdown options
          const found = assigneeOptions.find((opt: any) => opt.value === id);
          if (found) return found.label;

          // 2. Fallback if label already present (for API/search select)
          if (item?.label) return item.label;

          return "";
        });

        assigneeName = names.filter(Boolean).join(", ");
      }

      const formattedTask = {
        key: editingKey ?? Date.now(),
        TaskDetailId: editingKey ? values?.taskDetailId : null,
        taskTitle: values.taskTitle,
        taskDescription: values.taskDescription,
        // assignedToId: values.assignedToId?.value ?? values.assignedToId,
        assignedToId: Array.isArray(values.assignedToId)
          ? values.assignedToId.map((x: any) => x?.value ?? x)
          : values.assignedToId?.value ?? values.assignedToId,
        name: assigneeName,
        AssignedToIds: Array.isArray(values.assignedToId) ? values.assignedToId.map((x: any) => x?.value ?? x).join(',') : values.assignedToId?.value ?? values.assignedToId,
        statusId: values.statusId?.value ?? values.statusId,
        taskDeadline: values.taskDeadline
          ? dayjs(values.taskDeadline).format("YYYY-MM-DD")
          : null,
        remarks: values.remarks,
      };

      if (editingKey) {
        const updatedData = taskDetailsData?.map((item: any) =>
          item.key === editingKey ? formattedTask : item
        );
        setTaskDetailsData(updatedData);
        setEditingKey(null);
      } else {
        setTaskDetailsData((prev: any) => [...prev, formattedTask]);
      }

      form.resetFields(Fields);
      resetActionTab();

      //form.resetFields();

    } catch (error) {
      console.log("Validation Failed:", error);
    }
  };

  const handleUpdate = async () => {
    await withLoader(async () => {
      try {
        if (isValidTaskOwner) {
          await form.validateFields(["statusId", "remarks"]);
        } else if (
          (isValidInvestigator) &&
          taskCurrentStatus == TaskStatusEnum.Closed
        ) {
          await form.validateFields(["InvestigatorStatus", "taskClosureRemarks"]);
        } else if (
          isValidInvestigator
        ) {
          console.log("validating fields for RnD manager/ head");
          await form.validateFields(["assignedToId", "taskDeadline"]);
        }

        const values = form.getFieldsValue();
        console.log("values update===>", values, "edit key", editingKey);

        const formattedTask = {
          key: editingKey ?? Date.now(),
          TaskDetailId: editingKey ? values?.taskDetailId : null,
          taskTitle: values.taskTitle,
          taskDescription: values.taskDescription,
          AssignedToIds: values.assignedToId?.value ?? values.assignedToId,
          statusId: values.statusId?.value ?? values.statusId,
          taskDeadline: values.taskDeadline
            ? dayjs(values.taskDeadline).format("YYYY-MM-DD")
            : null,
          remarks: values.remarks,
          InvestigatorStatus:
            values.InvestigatorStatus?.value ?? values.InvestigatorStatus,
          taskClosureRemarks: values.taskClosureRemarks,
        };

        console.log("formatted task for update =>", formattedTask);
        if (
          formattedTask?.statusId == TaskStatusEnum.Pending &&
          commonContextParams?.roleId == RoleEnum.TaskActionOwner
        ) {
          message.error("Task cannot be moved back to Pending status.");
          console.error("Task cannot be moved back to Pending status.");
          return;
        }

        const assignTo = Array.isArray(values?.assignedToId)
          ? values.assignedToId.map((item: any) => item?.value ?? item)
          : typeof values?.assignedToId === "object" &&
            values?.assignedToId !== null
            ? values.assignedToId.value
            : values?.assignedToId;

        const formData = new FormData();

        formData.append("RequestId", location?.state?.RId);
        formData.append("TaskDetailId", editingKey ? String(editingKey) : "0");
        formData.append("TaskTitle", values?.taskTitle);
        formData.append("TaskDescription", values?.taskDescription);
        formData.append("AssignedToIds", assignTo);
        //formData.append("AssignedToIds", values?.assignedToId);
        formData.append(
          "TaskDeadline",
          values?.taskDeadline
            ? dayjs(values?.taskDeadline).format("YYYY-MM-DD")
            : "",
        );

        // if (isValidInvestigator && (values?.statusId == undefined || values?.statusId == null || values?.statusId == "")) {
        //   formData.append("StatusId", values?.statusId || TaskStatusEnum.Pending);
        // }
        // else{
        //   formData.append("StatusId", values?.statusId);
        // }
        formData.append("StatusId", values?.statusId);
        formData.append("Remarks", values?.remarks || "");
        formData.append("InvestigatorStatusId", values?.InvestigatorStatus || "");
        formData.append(
          "InvestigatorClosureRemarks",
          values?.taskClosureRemarks || "",
        );
        formData.append("CreatedBy", commonContextParams?.userId);
        formData.append("RoleId", commonContextParams?.roleId);

        // OWNER FILES
        ownerFiles?.forEach((file) => {
          if (file?.originFileObj) {
            formData.append("OwnerAttachments", file?.originFileObj);
          }
        });

        formData.append(
          "OwnerAttachmentIds",
          ownerFiles
            ?.filter((f: any) => f?.id)
            ?.map((f: any) => f?.id)
            ?.join(","),
        );

        const res = await API.post(UpdateTaskAsync, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        console.log("updated res by task owner =>", res);

        if (res?.data?.data?.length > 0) {
          message.success("Investigative Action updated successfully");
          var TaskData = await fetchTaskSummaryDetails();
          setShowForm(false);
          if (isValidTaskOwner) {
            const allClosed = TaskData?.every(
              (task: any) => task.statusId === TaskStatusEnum.Closed,
            );

            if (allClosed) {
              // navigate(-1);
              redirectToDashboard();
            }
          } else if (isValidInvestigator) {
            const allClosed = TaskData?.every(
              (task: any) => task.investigatorStatusId === TaskStatusEnum.Closed,
            );

            if (allClosed) {
              //navigate(-1);
              redirectToDashboard();
            }
          }


          setEditingKey(null);
          if (commonContextParams?.roleId == RoleEnum.TaskActionOwner) {
            form.resetFields([
              "taskTitle",
              "taskDescription",
              "assignedToId",
              "taskDeadline",
              "statusId",
              "remarks",
              "ownerAttachments",
            ]);
          } else if (
            commonContextParams?.roleId == RoleEnum.Investigator
          ) {
            form.resetFields([
              "taskTitle",
              "taskDescription",
              "assignedToId",
              "taskDeadline",
              "statusId",
              "remarks",
              "ownerAttachments",
              "InvestigatorStatus",
              "taskClosureRemarks",
            ]);
          }

          resetActionTab();
          setOwnerFiles([]);
          setClosureFiles([]);
          setIsEditing(false);
        } else {

          const data = res?.data;

          if (data?.status === ApiStatus.OK || data?.status === ApiStatus.Success) {
            //SUCCESS CASE
            message.success(data?.message?.trim() || "Investigative Action updated successfully");
            //navigate(-1);
            redirectToDashboard();
          } else {
            //ERROR CASE
            const errorMessage =
              (data?.errorCode === "DB_VALIDATION" || data?.errorCode === "DBVALIDATION")
                ? data?.message?.trim() || "Failed"
                : "Something went wrong!";

            message.error(errorMessage);
          }
        }
      } catch (error) {
        console.log("Validation Failed:", error);
      }
    });
  };

  const handleEdit = (record: any) => {
    resetActionTab();
    console.log('record in edit =>', record);
    setEditingKey(record.key);
    // if (record?.statusId == TaskStatusEnum.Closed || isValidTaskOwner) {
    //   setEditingKey(record.key);
    // }

    setIsEditing(true);
    setTaskCurrentStatus(record?.statusId);
    setCurrentInvestigatorStatus(record?.investigatorStatusId)
    setIsCurrentTaskExtended(record?.isExtended);
    setisReopenRequest(false);

    if (record?.investigatorStatusId == TaskStatusEnum.Closed) {
      setisAddDisable(true);
    }
    setisTaskTable(true);

    // --- Fix: Ensure Assigned To dropdown is set for new (unsaved) tasks ---
    if (record.assignedToId) {
      const ids = Array.isArray(record.assignedToId)
        ? record.assignedToId
        : [record.assignedToId];

      // If names are available (new/unsaved row)
      if (record.name) {
        const names = Array.isArray(record.name)
          ? record.name
          : record.name.split(","); // fallback if comma-separated

        const options = ids.map((id: any, index: number) => ({
          value: id,
          label: names[index]?.trim() || `User ${id}`, // safe fallback
        }));

        setAssigneeOptions(options);

        // cache all
        ids.forEach((id: any, index: number) => {
          assigneeCache.current.set(id.toString(), options[index]);
        });

      } else {
        // Fallback to normal fetch for existing tasks (multiple)
        ids.forEach((id: any) => {
          fetchCurrentAssignedUser(id);
        });
      }
    } else {
      setAssigneeOptions([]);
    }

    ////Scroll to section based on role and task status
    var sectionName = "";
    if (isValidInvestigator &&
      record?.statusId == TaskStatusEnum.Closed &&
      record?.investigatorStatusId != TaskStatusEnum.Closed) {
      sectionName = "action-investigator-section";
    } else if (isValidTaskOwner && record?.statusId != TaskStatusEnum.Closed) {
      sectionName = "action-owner-section";
    } else {
      sectionName = "action-initiation-section";
    }
    scrollToSection(sectionName);
    console.log('scrolling to section =>', sectionName);
    // setTimeout(() => {
    //   const element = document.getElementById(sectionName);
    //   if (element) {
    //     element.scrollIntoView({
    //       behavior: "smooth",
    //       block: "start"
    //     });
    //   }
    // }, 200);

    form.setFieldsValue({
      taskTitle: record.taskTitle,
      taskDescription: record.taskDescription,
      assignedToId: record.assignedToId,
      assignedToIds: record.assignedToId
        ? (Array.isArray(record.assignedToId)
          ? record.assignedToId.map((id: any, index: number) => ({
            value: id,
            label: Array.isArray(record.name)
              ? record.name[index]
              : record.name?.split(",")[index]?.trim(),
          }))
          : {
            value: record.assignedToId,
            label: record.name,
          })
        : undefined,
      taskDeadline: record.taskDeadline
        ? dayjs(record.taskDeadline)
        : null,
      statusId: record.statusId,
      remarks: record.statusId == TaskStatusEnum.Closed ? record.remarks : "",
      InvestigatorStatus: record?.investigatorStatusId,
      taskClosureRemarks: record?.investigatorClosureRemarks
    });

    if (record?.taskOwnerAttachments) {
      const parsed = JSON.parse(record.taskOwnerAttachments);

      const owner = parsed.map((file: any) => ({
        uid: file.id.toString(),
        name: file.name,
        status: "done",
        url: file.path,
        existing: true,
        id: file.id,
      }));

      setOwnerFiles(owner);

    } else {
      setOwnerFiles([]);
    }
  };

  const handleDelete = (record: any) => {
    const updatedData = taskDetailsData.filter((item: any) => item.key !== record.key);
    setTaskDetailsData(updatedData);
  }

  const fetchTaskSummaryDetails = async () => {
    const res = await API.post(getTaskSummaryDetails,
      {
        RequestId: location?.state?.RId,
        CreatedBy: commonContextParams?.userId,
        RoleId: commonContextParams?.roleId
      })
    // console.log('Task summary details response', res); 
    if (res?.data?.data?.length > 0) {
      // const formattedData = res?.data?.data?.map((item: any) => ({
      //   ...item,
      //   key: item?.taskDetailId,
      //   assignedToId: item?.assignedToIds
      //     ? item.assignedToIds.split(",").map((id: any) => Number(id))
      //     : [],

      //   Name: item?.name || "-"
      // }));

      const formattedData = res?.data?.data?.map((item: any) => {
        const ids = item?.assignedToIds
          ? item.assignedToIds.split(",").map((id: any) => Number(id))
          : [];

        const names = item?.name ? item.name.split(",") : [];

        // 🔥 STORE ID → NAME mapping
        ids.forEach((id: number, index: number) => {
          const label = names[index]?.trim();

          if (label) {
            assigneeIdCache.current.set(id, { value: id, label });
            assigneeFromTaskSummary.current.set(id, label);
          }
        });

        return {
          ...item,
          key: item?.taskDetailId,
          assignedToId: ids,
          name: item?.name || "-"
        };
      });

      setTaskDetailsData(formattedData);
      return formattedData;
    }
  }

  const handleSubmit = async () => {
    await withLoader(async () => {
      if (
        Number(commonContextParams?.roleId) === RoleEnum.Investigator &&
        requestStatus === RequestStatusEnum.ActionAssignmentPendingWithInvestigator
      ) {
        if (!taskDetailsData || taskDetailsData.length === 0) {
          message.error("Please add at least one task.");
          return;
        }
      }

      if (taskDetailsData?.length > 0) {
        // const allFields = form.getFieldsValue();
        console.log('all fields=>', taskDetailsData);
        const req = {
          TaskSummaryList: taskDetailsData || [],
          CreatedBy: commonContextParams?.userId,
          RequestId: location.state ? location.state?.RId : 0,
          RoleId: commonContextParams?.roleId,
        }
        const res = await API.post(InsertTasksAsync, req);
        console.log('result on submit =>', res)
        const data = res?.data;

        if (data?.status === ApiStatus.OK || data?.status === ApiStatus.Success) {
          //SUCCESS CASE
          message.success(data?.message?.trim() || "Task submitted successfully");
          //navigate(-1);
          redirectToDashboard();
        } else {
          //ERROR CASE
          const errorMessage =
            (data?.errorCode === "DB_VALIDATION" || data?.errorCode === "DBVALIDATION")
              ? data?.message?.trim() || "Failed"
              : "Something went wrong!";

          message.error(errorMessage);
        }

      } else {
        console.log('inside else ')
        message.error("Assign at least one task!")
      }
    });
  }

  //#endregion

  //#region On Load Call Methods

  const scrollToSection = (sectionName: string) => {
    requestAnimationFrame(() => {
      const element = document.getElementById(sectionName);

      if (element) {
        const yOffset = -80; // adjust if header exists
        const y =
          element.getBoundingClientRect().top +
          window.pageYOffset +
          yOffset;

        window.scrollTo({
          top: y,
          behavior: "smooth"
        });
      }
    });
  };

  const redirectToDashboard = () => {
    const roleId = Number(commonContextParams?.roleId);

    if (roleId === Number(RoleEnum.TaskActionOwner)) {
      navigate("/ActionDashboard");
    } else if (roleId === Number(RoleEnum.CorrectiveActionOwner)) {
      navigate("/CorrectiveActionDashboard");
    } else {
      navigate("/ComplaintsDashboard");
    }
  };

  const handleAssigneeSearch = async (searchValue: string) => {
    if (assigneeSearchTimeout.current) {
      clearTimeout(assigneeSearchTimeout.current);
    }

    if (!searchValue || searchValue.trim().length < 2) {
      setAssigneeOptions([]);
      setAssigneeLoading(false);
      return;
    }

    // Cache check
    if (assigneeCache.current.has(searchValue)) {
      setAssigneeOptions((prev: any) => {
        const cached = assigneeCache.current.get(searchValue) || [];
        const merged = [...prev, ...cached];

        return Array.from(
          new Map(merged.map((item) => [item.value, item])).values()
        );
      });
      setAssigneeLoading(false);
      return;
    }

    setAssigneeLoading(true);

    assigneeSearchTimeout.current = setTimeout(async () => {
      try {
        const res = await API.post(getAssignedTo, {
          SearchTerm: searchValue.trim(),
        });

        if (res?.data?.data?.length > 0) {
          const options = res.data.data.map((item: any) => ({
            label: item?.name,
            value: item?.Id,
          }));

          options.forEach((opt: any) => {
            assigneeIdCache.current.set(opt.value, opt);
          });

          // Cache by search term
          assigneeCache.current.set(searchValue, options);

          // 🔥 CHANGE: merge instead of overwrite
          setAssigneeOptions((prev: any) => {
            const merged = [...prev, ...options];

            return Array.from(
              new Map(merged.map((item) => [item.value, item])).values()
            );
          });
        } else {
          setAssigneeOptions([]);
        }
      } catch (error) {
        console.error("Error fetching assignees:", error);
        setAssigneeOptions([]);
      } finally {
        setAssigneeLoading(false);
      }
    }, 300);
  };

  const fetchCurrentAssignedUser = async (assignedToId: any) => {
    try {
      const ids = Array.isArray(assignedToId)
        ? assignedToId
        : [assignedToId];

      let options: any[] = [];

      ids.forEach((id: any) => {
        // 1. Task summary cache
        const cachedName = assigneeFromTaskSummary.current.get(id);
        if (cachedName) {
          options.push({ label: cachedName, value: id });
          return;
        }

        // 2. Form options
        if (formOptions?.Assignee?.length > 0) {
          const foundUser = formOptions.Assignee.find(
            (opt: any) => opt.value === id
          );
          if (foundUser) {
            options.push(foundUser);
          }
        }
      });

      if (options.length > 0) {
        // 🔥 ADD THIS (IMPORTANT)
        options.forEach((opt) => {
          assigneeIdCache.current.set(opt.value, opt); // ✅ store proper cache
        });
        // cache each id
        options.forEach((opt) => {
          assigneeCache.current.set(opt.value.toString(), [opt]);
        });

        // 🔥 CHANGE: merge instead of overwrite
        setAssigneeOptions((prev: any) => {
          const merged = [...prev, ...options];

          return Array.from(
            new Map(merged.map((item) => [item.value, item])).values()
          );
        });

        return;
      }

      setAssigneeOptions([]);
    } catch (error) {
      console.error("Error fetching assigned user:", error);
      setAssigneeOptions([]);
    }
  };

  useEffect(() => {
    const getAssignees = async () => {
      const res = await API.post(getAssignedTo, {})
      // console.log('assignees response', res); 
      if (res?.data?.data?.length > 0) {

        const assignees = res?.data?.data?.map((item: any) => ({
          label: item?.name,
          value: item?.Id,
        }));
        setFormOptions((prev: any) => ({ ...prev, Assignee: assignees }));

      }
    };

    const getStatusOptions = async () => {
      const res = await API.post(getTaskOwnerStatus, {})
      //  console.log('status options response', res); 
      if (res?.data?.data?.length > 0) {
        const statusOptions = res?.data?.data?.map((item: any) => ({
          label: item?.name,
          value: item?.Id,
        }));
        setFormOptions((prev: any) => ({ ...prev, Status: statusOptions }));
      }
    };

    const getInvestigatorStatusOptions = async () => {
      const res = await API.post(getTaskInvestigatorStatus, {})
      // console.log('Investigator status options response', res);
      if (res?.data?.data?.length > 0) {
        const InvestigatorStatusOptions = res?.data?.data?.map((item: any) => ({
          label: item?.name,
          value: item?.Id,
        }));

        setFormOptions((prev: any) => ({ ...prev, InvestigatorStatus: InvestigatorStatusOptions }));
      }
    }

    getAssignees();
    getStatusOptions();
    getInvestigatorStatusOptions();

  }, [])

  useEffect(() => {
    let isMounted = true; // 🔥 track component state

    return () => {
      isMounted = false;

      if (assigneeSearchTimeout.current) {
        clearTimeout(assigneeSearchTimeout.current);
      }
    };
  }, []);

  const fetchRequestDetailsById = async (id: any) => {
    const res = await API.post(getRequestDetailsById, { RequestId: id })
    console.log('Request details by id response', res);
    if (res?.data?.data?.length > 0) {
      setRequestStatus(res?.data?.data[0]?.requestStatusId);
      setInvestigator(res?.data?.data[0]?.investigator);

      //#region Hide/Show Form Logic
      const roleId = Number(commonContextParams.roleId);
      const statusId = res?.data?.data[0]?.requestStatusId;

      const isInvestigatorCase =
        roleId === RoleEnum.Investigator &&
        statusId === RequestStatusEnum.ActionAssignmentPendingWithInvestigator;

      if (location?.state.IsTaskDashboard == true ||
        location?.state.IsCorrActionDashboard == true ||
        isInvestigatorCase //|| isQACase
      ) {
        setShowForm(true);
      }
      //#endregion

      let closureDate = dayjs(res?.data?.data[0]?.requestClosureDate);
      console.log('closure date=>', closureDate)
      console.log(currentInvestigatorStatus);
      setClosureDate(closureDate.format('YYYY-MM-DD'));

      return res?.data?.data[0];

    }
  }

  useEffect(() => {
    (async () => {
      if (location?.state?.RId && location?.state?.RId > 0) {
        await withLoader(async () => {   // 🔥 ADDED

          const [data, res] = await Promise.all([  // 🔥 UPDATED
            fetchTaskSummaryDetails(),
            fetchRequestDetailsById(location?.state?.RId)
          ]);

          if (location?.state?.TId && location?.state?.TId > 0) {
            console.log('location?.state?.TaskDetailId =>', location?.state?.TId, ' data=>', data)
            const obj = data?.find((e: any) => e.taskDetailId == location?.state?.TId)
            console.log('objjj=>', obj)

            if (location?.state.IsTaskDashboard == true ||
              location?.state.IsCorrActionDashboard == true) {
              setIsEditing(true);
            } else {
              setIsEditing(false);
            }

            setEditingKey(obj.key);
            setTaskCurrentStatus(obj?.statusId);
            setIsCurrentTaskExtended(obj?.isExtended);
            setCurrentInvestigatorStatus(obj?.investigatorStatusId);

            // Fetch the currently assigned user(s) to show in the dropdown
            if (obj?.assignedToId) {
              const ids = Array.isArray(obj.assignedToId)
                ? obj.assignedToId.map((item: any) => item?.value ?? item)
                : [obj.assignedToId?.value ?? obj.assignedToId];

              await fetchCurrentAssignedUser(ids);
            }

            form.setFieldsValue({
              taskTitle: obj.taskTitle,
              taskDescription: obj.taskDescription,
              assignedToId: obj.assignedToId?.map((id: number) => {
                const cached = assigneeIdCache.current.get(id);

                return {
                  value: id,
                  label: cached?.label || "", // always try real name
                };
              }),
              assignedToIds: obj?.assignedToId,
              taskDeadline: obj.taskDeadline
                ? dayjs(obj.taskDeadline)
                : null,
              statusId: obj.statusId,
              remarks: obj.remarks,
              InvestigatorStatus: obj?.investigatorStatusId,
              taskClosureRemarks: obj?.investigatorClosureRemarks
            });

            if (obj?.taskOwnerAttachments) {
              const parsedOwner = JSON.parse(obj?.taskOwnerAttachments);

              const owner = parsedOwner.map((file: any) => ({
                uid: file.id.toString(),
                name: file.name,
                status: "done",
                url: file.path,
                id: file.id,
              }));

              setOwnerFiles(owner);
            }

          }
        }); // 🔥 ADDED
      }
    })();
  }, [location?.state?.RId])

  //#endregion

  //#region Attchement Helper
  const handleOwnerRemove = (file: any) => {
    if (file?.id) {
      setDeletedOwnerAttachmentIds((prev) =>
        prev ? `${prev},${file.id}` : `${file.id}`,
      );
    }

    setOwnerFiles((prev) => prev.filter((f) => f.uid !== file.uid));
  };

  const beforeUpload = useCallback(
    (file: File, fileList: UploadFile[]): boolean | typeof Upload.LIST_IGNORE => {
      setAlertMessage("");
      const ext = extractFileExtension(file.name);
      const allowed = acceptedTypes.split(",").includes(ext);
      if (!allowed) {
        setAlertMessage(`Only ${acceptedTypes} files are allowed.`);
        return Upload.LIST_IGNORE;
      }
      if (maxDocCount !== 1 && fileList.length >= maxDocCount) {
        setAlertMessage(`You can only upload a maximum of ${maxDocCount} files.`);
        return Upload.LIST_IGNORE;
      }

      if (maxFileSize && file.size > maxFileSize * 1024 * 1024) {
        setAlertMessage(
          `File ${file.name} exceeds the maximum size of ${maxFileSize} MB.`
        );
        return Upload.LIST_IGNORE;
      }

      if (totalMaxFilesSize) {
        const totalSize =
          fileList.reduce((sum: any, f: any) => sum + (f.size || 0), 0) + file.size;

        if (totalSize > totalMaxFilesSize * 1024 * 1024) {
          setAlertMessage(
            `Total file size exceeds the maximum of ${totalMaxFilesSize} MB.`
          );
          return Upload.LIST_IGNORE;
        }
      }

      return false;
    },
    [acceptedTypes, fileList.length, maxDocCount, maxFileSize, totalMaxFilesSize]
  );
  const extractFileExtension = (fileName: string): string =>
    fileName.substring(fileName.lastIndexOf(".")).toLowerCase();

  const openFile = (file: any) => {
    const docPath = file.path ?? file.url;

    if (!docPath) {
      console.error("Missing docPath for file", file);
      return;
    }

    window.open(docPath, "_blank");
  };
  //#endregion

  const withLoader = async (fn: any) => {
    try {
      setLoading(true);
      await fn();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loader />}

      <Col lg={24}>
        <Form
          form={form}
          layout="vertical"
          validateTrigger="onChange"
          initialValues={{ active: true }}
        //disabled={disableForm}
        >
          <Row gutter={[16, 16]} key={"newform"}>

            {ShowForm || isEditing ? (
              // {canShowForm ? (
              <>

                {/* <Divider style={{ fontWeight: "bold", color: "#ee2d24" }}>
                  Investigative Action Detail
                </Divider> */}

                <div id="action-initiation-section">  </div>

                <Col lg={6} xs={24} sm={24} md={12}>
                  <Form.Item
                    name="taskTitle"
                    label="Action Title"
                    rules={[
                      {
                        required: true,
                        message: "Please enter a action title",
                      },
                      {
                        max: 100,
                        message: "action title cannot exceed 100 characters"
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter Action Title"
                      disabled={!(
                        isValidInvestigator &&
                        requestStatus === RequestStatusEnum.ActionAssignmentPendingWithInvestigator &&
                        currentInvestigatorStatus !== TaskStatusEnum.Closed
                      )}
                      maxLength={100}
                    // showCount
                    />
                  </Form.Item>
                </Col>

                <Col lg={6} xs={24} sm={24} md={12}>
                  <Form.Item
                    name="taskDescription"
                    label="Action Description"
                    rules={[
                      {
                        required: true,
                        message: "Please enter a action description",
                      },
                    ]}
                  >
                    <Input.TextArea
                      placeholder="Enter Action Description"
                      disabled={!(
                        isValidInvestigator &&
                        requestStatus === RequestStatusEnum.ActionAssignmentPendingWithInvestigator &&
                        currentInvestigatorStatus !== TaskStatusEnum.Closed
                      )}
                      rows={4}
                      maxLength={1000}
                      showCount
                    />
                  </Form.Item>
                </Col>

                <Col lg={6} xs={24} sm={24} md={12}>
                  <Form.Item
                    name="assignedToId"
                    label="Assigned To"
                    rules={[
                      { required: true, message: "Please select an assignee" },
                    ]}
                  >
                    <Select
                      placeholder="Type at least 2 characters to search"
                      mode="multiple"
                      labelInValue // 🔥 IMPORTANT: required for multi-select objects
                      options={assigneeOptions || []}
                      allowClear
                      showSearch
                      filterOption={false}
                      onSearch={handleAssigneeSearch}
                      notFoundContent={
                        assigneeLoading ? (
                          <div style={{ textAlign: "center", padding: "10px" }}>
                            <Spin size="small" />
                          </div>
                        ) : assigneeOptions.length === 0 ? ( // 🔥 FIXED CONDITION
                          "Type at least 2 characters to search"
                        ) : (
                          "No users found"
                        )
                      }
                      optionFilterProp="label"
                      disabled={
                        !(
                          isValidInvestigator &&
                          (
                            requestStatus === RequestStatusEnum.TasksWipWithTaskOwner ||
                            requestStatus === RequestStatusEnum.ActionAssignmentPendingWithInvestigator
                          ) &&
                          taskCurrentStatus != TaskStatusEnum.Closed
                        )
                      }
                    />
                  </Form.Item>
                </Col>

                <Col lg={6} xs={24} sm={24} md={12}>
                  <Form.Item
                    name="taskDeadline"
                    label="Action Deadline"
                    rules={[{ required: true, message: "Action deadline is required!" }]}
                  >
                    <FormDatePicker
                      name="taskDeadline"
                      label=""
                      placeholder="Select Action Deadline"
                      format="DD-MM-YYYY"
                      disabled={!(
                        isValidInvestigator &&
                        (
                          requestStatus === RequestStatusEnum.TasksWipWithTaskOwner ||
                          requestStatus === RequestStatusEnum.ActionAssignmentPendingWithInvestigator
                        ) &&
                        taskCurrentStatus != TaskStatusEnum.Closed &&
                        (isCurrentTaskExtended == false ||
                          isCurrentTaskExtended == null)
                      )}
                      disabledDate={(current: any) => {
                        return (
                          current &&
                          current.isBefore(dayjs().startOf("day"))
                        );
                      }}
                    />
                  </Form.Item>
                </Col>

                {
                  ((requestStatus == RequestStatusEnum.TasksWipWithTaskOwner || isReopened) &&
                    editingKey
                  ) ||
                    requestStatus == RequestStatusEnum.CorrectiveActionAssignmentPendingWithQa ||
                    requestStatus == RequestStatusEnum.CorrectiveActionsWipWithOwner ||
                    requestStatus == RequestStatusEnum.AllCorrectiveActionsClosed ||
                    requestStatus == RequestStatusEnum.CustomerRatingPending ||
                    requestStatus == RequestStatusEnum.CustomerRatingsUnderReview ||
                    requestStatus == RequestStatusEnum.ComplaintClosed
                    ? (
                      <>

                        <div id="action-owner-section">  </div>

                        <Col lg={6} xs={24} sm={24} md={12}>
                          <Form.Item
                            name="statusId"
                            label="Status"
                            rules={[
                              { required: true, message: "Please select a status" },
                            ]}
                          >
                            <Select
                              placeholder="Select Status"
                              options={formOptions?.Status || []}
                              allowClear
                              disabled={
                                !(taskCurrentStatus !== TaskStatusEnum.Closed &&
                                  isValidTaskOwner)
                              }
                              maxTagCount="responsive"
                            />
                          </Form.Item>
                        </Col>

                        <Col lg={6} xs={24} sm={24} md={12}>
                          <Form.Item
                            name="remarks"
                            label="Remarks"
                            rules={[
                              {
                                required: true,
                                message: "Please enter remarks",
                              },
                            ]}
                          >
                            <Input.TextArea
                              placeholder="Enter Remarks"
                              disabled={
                                !(taskCurrentStatus !== TaskStatusEnum.Closed &&
                                  isValidTaskOwner)
                              }
                              rows={4}
                              maxLength={1000}
                              showCount
                            />
                          </Form.Item>
                        </Col>

                        <Col lg={6} xs={24} sm={24} md={12}>
                          {alertMessage && <Alert message={alertMessage} type="warning" showIcon />}
                          <Form.Item label="Attachments" name={"ownerAttachments"}>
                            <Upload
                              multiple
                              maxCount={maxDocCount}
                              fileList={ownerFiles}
                              beforeUpload={beforeUpload}
                              accept={acceptedTypes}
                              onChange={({ fileList }) => {
                                setOwnerFiles(fileList.slice(0, 5));
                              }}
                              onRemove={handleOwnerRemove}
                              onPreview={openFile}
                              disabled={
                                !(taskCurrentStatus !== TaskStatusEnum.Closed &&
                                  isValidTaskOwner)
                              }
                            >
                              <Button icon={<UploadOutlined />}>Upload (Max : {maxDocCount})</Button>
                            </Upload>
                            {/* <label>({acceptedTypes})</label> */}
                            <label style={{
                              marginTop: 4,
                              wordBreak: "break-word",
                              whiteSpace: "normal"
                            }}>
                              {'(' + acceptedTypes + ')'}
                            </label>
                          </Form.Item>
                        </Col>

                        <Col lg={6} xs={24} sm={24} md={12}>
                          {/* content goes here */}
                        </Col>
                      </>)
                    :
                    (<></>)
                }

                {(taskCurrentStatus == TaskStatusEnum.Closed) ?
                  <>

                    <div id="action-investigator-section">  </div>

                    <Col lg={6} xs={24} sm={24} md={12}>
                      <Form.Item
                        name="InvestigatorStatus"
                        label="Investigator Status"
                        rules={[
                          { required: true, message: "Please select a status" },
                        ]}
                      >
                        <Select
                          placeholder="Select Status"
                          options={formOptions?.InvestigatorStatus || []}
                          allowClear
                          disabled={!isValidInvestigator || currentInvestigatorStatus === TaskStatusEnum.Closed}
                          // mode="multiple"
                          maxTagCount="responsive"
                        />
                      </Form.Item>
                    </Col>

                    <Col lg={6} xs={24} sm={24} md={12}>
                      <Form.Item
                        name="taskClosureRemarks"
                        label="Action Closure Remarks(Investigator)"
                        rules={[
                          {
                            required: true,
                            message: "Please enter remarks",
                          },
                        ]}
                      >
                        <Input.TextArea
                          placeholder="Enter Remarks"
                          disabled={!isValidInvestigator || currentInvestigatorStatus === TaskStatusEnum.Closed}
                          rows={4}
                          maxLength={1000}
                          showCount

                        />
                      </Form.Item>
                    </Col>

                    <Col lg={6} xs={24} sm={24} md={12}>
                      {/* content goes here */}
                    </Col>

                    <Col lg={6} xs={24} sm={24} md={12}>
                      {/* content goes here */}
                    </Col>

                  </>
                  :
                  <></>
                }


                <Col lg={24} xs={24} sm={24} md={12}>
                  <div className="text-end">

                    {_showUpdateButton && (
                      <Button
                        className="btn-submit"
                        onClick={() => handleUpdate()}
                        disabled={_disableUpdate}
                      >
                        Update
                      </Button>
                    )}

                    {!_showUpdateButton && _showInvestigatorAdd && (
                      <Button
                        className="btn-submit"
                        onClick={handleAdd}
                        disabled={
                          requestStatus === RequestStatusEnum.TasksWipWithTaskOwner || isAddDisable
                        }
                      >
                        Add
                      </Button>
                    )}

                    {_showReset && (
                      <Button
                        className="btn-reset"
                        onClick={resetActionTab}
                        style={{ marginLeft: 8 }}
                      >
                        Reset
                      </Button>
                    )}

                  </div>
                </Col>
              </>
            ) : (
              <></>
            )}

            <Col lg={24} xs={24} sm={24} md={24}>
              {
                taskDetailsData && taskDetailsData?.length > 0 ?
                  <>
                    <div style={{ marginBottom: "16px" }}>
                      <h6
                        style={{
                          marginBottom: "4px",
                          fontWeight: 600,
                          borderBottom: "2px solid #d9d9d9",
                          paddingBottom: "6px",
                          display: "inline-block"
                        }}
                      >
                        Investigative Action Summary
                      </h6>

                      {/* <div style={{ fontSize: "12px", color: "#888", fontWeight: "bold" }}>
                        *Please click on edit icon to update action
                      </div> */}

                      {(isValidInvestigator || isValidTaskOwner) && (
                        <div style={{ fontSize: "12px", color: "#888", fontWeight: "bold" }}>
                          *Please click on edit icon to update action
                        </div>
                      )}

                    </div>
                    <Table
                      columns={Taskcolumns}
                      dataSource={taskDetailsData}
                      pagination={false}
                    />
                  </>
                  :
                  <></>
              }
            </Col>
          </Row>
          {/* {
            requestStatus == RequestStatusEnum.TasksWipWithTaskOwner ? */}
          <div className='row'>
            <div className='d-flex justify-content-end gap-2'>
              <Button
                className=""
                onClick={goToPrevTab}
              >
                {"<"}
              </Button>
              <Button
                className=""
                onClick={goToNextTab}
              >
                {">"}
              </Button>


              <Button
                className="btn-submit"
                onClick={() => handleSubmit()}
                disabled={!(canInvestigatorSubmit)}
              >
                Submit
              </Button>

              {/* <Button className='btn-reset' onClick={() => { navigate(-1) }}> */}
              <Button className='btn-reset' onClick={() => { redirectToDashboard(); }}>
                Back
              </Button>

            </div>
          </div>
          {/* :
              <></>
          } */}


          <Modal
            title="Action History"
            open={isHistoryIconClicked}
            onOk={handleHistoryClose}
            onCancel={handleHistoryClose}
            footer={null}
            width={800}
            destroyOnClose
          >
            <Table
              columns={Historycolumns}
              dataSource={historyData || []}
              pagination={false}
              rowKey="id"
            />
          </Modal>

        </Form>
      </Col>
    </>
  )
}

export default TaskDetailsTab
